exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width:601px){.wrap-sub-list[data-v-80a0c0ac]{display:grid;grid-template-columns:repeat(2,minmax(0,1fr))}}", ""]);

// exports
